/**
 * Live default for the HR-summary control-modal group. Read by
 * `widgets/hr-summary/hrSummary/dailySummaryEcgViewerWrapper.tsx` and
 * `app/lib/reportUiEffects.test.tsx`.
 */
// eslint-disable-next-line import/prefer-default-export -- named import at every call site
export const defaultControlHrSummaryModalValue = {
  isShowModalSetMaxMinHr: false,
  isShowModalEditHr: false,
};
